import { TIER } from '@george-labs.com/design-system';

export const SCALE_MAX = 2.5;
export const SCALE_MIN = 1;
export const ZOOM_INCREMENT = 0.1;

export const IMAGE_EDITOR_BORDER_SIZE = 25;
const IMAGE_EDITOR_SIZE_XS = 200;
const IMAGE_EDITOR_SIZE = 300;
const SCALE_MULTIPLIER = 100;
const BORDER_COUNT = 2;

export function updateScaleBy(scale: number, delta: number): number {
    const updatedScale = Math.round((scale + delta) * SCALE_MULTIPLIER) / SCALE_MULTIPLIER;
    if (updatedScale > SCALE_MAX || updatedScale < SCALE_MIN) {
        return scale;
    }

    return updatedScale;
}

export function getImageEditorSize(tier: string): number {
    if (tier === TIER.XS) {
        return IMAGE_EDITOR_SIZE_XS;
    }

    return IMAGE_EDITOR_SIZE;
}

export function getCanvasWidth(editorSize: number): number {
    return editorSize + BORDER_COUNT * IMAGE_EDITOR_BORDER_SIZE;
}
